// import {Link} from 'react-router-dom'
import styles from './RequestDetails.module.scss'
import {
  // Box, 
  // Button, 
  // IconButton,
  Block,
  // UserAvatar,
  Text,
  IconTitle,
  RequestFifthIcon, //DotsIcon
} from 'common/components'
import { formatMoney as formatMoneyC, formatDate as formatDate5 } from 'common/helpers'

const formatDate = (date:string) => formatDate5(date, 'fifth')
const formatMoney= (n:number) => ((!!n) && ('number' === typeof n)) ? formatMoneyC(n, {cents: true}) : '--'
const formatPercentage=(n:number) => ((!!n) && ('number' === typeof n)) ? `${n}%` : '--'

interface RequestDetailsProps {
  // projectView?: boolean
  isConfirm?: boolean
  request: any
}

export default function VariationRequestDetails({
  request,
  isConfirm
}: RequestDetailsProps) {
  return (
    <Block className={styles.root} type="white">
      <div className={styles['journal-actions']}>
        <IconTitle icon={<RequestFifthIcon />}>
          Variation request details
        </IconTitle>
        {/* <IconButton className={styles.edit} >
          <DotsIcon />
        </IconButton> */}
      </div>

      <Text mb={8}  size="xs" color="grayer" weight="medium">Variation type</Text>
      <Text mb={24} size="xl" color="black"  weight="medium">
        {request.type}
      </Text>

      <div className={styles['variation-basic-info']}>
        <div>
          <Text mb={8} size="xs" color="grayer" weight="medium">Start day</Text>
          <Text size="xl" color="black"  weight="medium">
            {formatDate(
              (!!isConfirm && !!request.startDateConfirmed) ? 
              request.startDateConfirmed :
              request.startDate
            )}
          </Text>
        </div>
        <div>
          <Text mb={8} size="xs" color="grayer" weight="medium">Amount to be increased</Text>
          <Text size="xl" color="black"  weight="medium">
            {formatMoney(!isConfirm ? request.increaseAmount:request.increaseAmount)}
          </Text>
        </div>
        <div>
          <Text mb={8} size="xs" color="grayer" weight="medium">Initial drawdown</Text>
          <Text size="xl" color="black"  weight="medium">
            {formatMoney(!isConfirm ? request.initialDrawdown:request.initialDrawdownConfirmed)}
          </Text>
        </div>
      </div>
      <div className={styles['variation-basic-info']}>
        <div>
          <Text mb={8} size="xs" color="grayer" weight="medium">Interest rate</Text>
          <Text size="xl" color="black"  weight="medium">
            {formatPercentage(!isConfirm ? request.interest:request.interest)}
          </Text>
        </div>
        <div>
          <Text mb={8} size="xs" color="grayer" weight="medium">Legal fee</Text>
          <Text size="xl" color="black"  weight="medium">
            {formatMoney(!isConfirm ? request.legalFeeAmount:request.legalFeeAmountConfirmed)}
          </Text>
        </div>
        <div>
          <Text mb={8} size="xs" color="grayer" weight="medium">Broker fee</Text>
          <Text size="xl" color="black"  weight="medium">
            {formatMoney(!isConfirm ? request.brokerFeeAmount:request.brokerFeeAmountConfirmed)}
          </Text>
        </div>
      </div>

      <Text mb={4}  size="2xs" color="black" weight="demiBold">Comments</Text>
      <Text mb={24} size="xs"  color="black">
        {!isConfirm ? request.comment : request.commentConfirmed}
      </Text>
    </Block>
  )
}
